import React, {useEffect, useState} from 'react';
import axios from 'axios';
import {
    FormControl,
    InputLabel,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TablePagination,
    Button, TextField, Grid, MenuItem, Select, Stack, LinearProgress, Typography, InputAdornment, IconButton, Chip,

} from '@mui/material';
import ConfirmationModal from '../../../components/ConfirmationModal/ConfirmationModal';
import CustomAlert from '../../../components/ConfirmationModal/CustomAlert';
import {AiOutlineClear,  AiOutlineSearch} from "react-icons/ai";
import LoaderCustomFixed from "../../../components/ConfirmationModal/LoaderCustomFixed";
import {MdArrowDownward, MdArrowUpward, MdBlock, MdCheck, MdClear, MdDelete, MdLockReset} from "react-icons/md";

function UserFetcher() {
    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const [pageSize, setPageSize] = useState(10);
    const [page, setPage] = useState(0);
    const [users, setUsers] = useState([]);
    const [totalUsers, setTotalUsers] = useState(0);
    const [modalOpen, setModalOpen] = useState(false);
    const [selectedUserId, setSelectedUserId] = useState(null);
    const [alertMessage, setAlertMessage] = useState('');
    const [showAlert, setShowAlert] = useState(false);
    const [reactivateUserId, setReactivateUserId] = useState(null);
    const [deleteUserId, setDeleteUserId] = useState(null);
    const [reactivateModalOpen, setReactivateModalOpen] = useState(false);
    const [deleteModalOpen, setDeleteModalOpen] = useState(false);
    const [passwordResetModalOpen, setPasswordResetModalOpen] = useState(false);
    const [passwordResetEmail, setPasswordResetEmail] = useState('')
    const [firstNameFilter, setFirstNameFilter] = useState('');
    const [lastNameFilter, setLastNameFilter] = useState('');
    const [emailFilter, setEmailFilter] = useState('');
    const [isActive, setIsActive] = useState("all");
    const [personalNumberFilter, setPersonalNumberFilter] = useState('');
    const [phoneNumberFilter, setPhoneNumberFilter] = useState('');
    const [resetFilters, setResetFilters] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [sizeInMb, setSizeInMb] = useState(null);
    const [isLoadingMbSize, setIsLoadingMbSize] = useState(true);
    const [sortByFileSize, setSortByFileSize] = useState(false);

    const activeFilters = [
        {label: 'სახელი', value: firstNameFilter, setValue: setFirstNameFilter},
        {label: 'გვარი', value: lastNameFilter, setValue: setLastNameFilter},
        {label: 'ელ-ფოსტა', value: emailFilter, setValue: setEmailFilter},
        {label: 'პირადი ნომერი', value: personalNumberFilter, setValue: setPersonalNumberFilter},
        {label: 'ტელეფონი', value: phoneNumberFilter, setValue: setPhoneNumberFilter},
        {
            label: 'აქტიური',
            value: isActive !== 'all' ? (isActive ? 'აქტიური' : 'არააქტიური') : '',
            setValue: () => setIsActive('all')
        }
    ];


    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/GetSettingByKeyWord?Keyword=AddCaseFile`);
                if (response.data && response.data.success && response.data.data.data) {
                    const additionalValue = response.data.data.data[0].additionalValue;

                    // Try parsing the numeric value from "additionalValue"
                    const maxSizeInMb = parseInt(additionalValue.split('_')[0], 10);

                    // Set to default (1024) if parsing fails or results in NaN
                    setSizeInMb(isNaN(maxSizeInMb) ? 1024 : maxSizeInMb);
                }
            } catch (error) {
                setSizeInMb(1024);
            } finally {
                setIsLoadingMbSize(false);
            }
        };

        void fetchData();
    }, []);


    const getFilters = () => {
        let filters = [];
        const addFilter = (name, value, type = 'String', Dynamic = false, GreaterDateTime = false) => {

            if (value || value === 0) {
                if (type === 'numeric') {
                    value = Number(value);
                }
                filters.push(`Filter[${filters.length}].FieldName=${name}&Filter[${filters.length}].${type}Value=${value}&Filter[${filters.length}].Dynamic=${Dynamic}&Filter[${filters.length}].GreaterDateTime=${GreaterDateTime}`);
            }
        };
        addFilter('firstName', firstNameFilter, 'String', false)
        addFilter('lastName', lastNameFilter, 'String', false)
        addFilter('email', emailFilter, 'String', false)
        addFilter('pNumber', personalNumberFilter, 'String', false)


        return filters.join('&');
    };


    const openPasswordResetModal = (email) => {
        setPasswordResetEmail(email);
        setPasswordResetModalOpen(true);
    };
    const handlePasswordReset = async () => {
        try {
            await axios.post(`${baseURL}/User/ForgetPassword`, {
                email: passwordResetEmail,
            });
            setAlertMessage('ოპერაცია წარმატებით დასრულდა');
            setShowAlert(true);
        } catch (error) {
            setAlertMessage("დაფიქსირდა შეცდომა, ცადეთ მოგვიანებით");
            setShowAlert(true);
        } finally {
            setPasswordResetModalOpen(false);
        }
    };

    useEffect(() => {
        void fetchUsers();
    }, [pageSize, page, sortByFileSize]);

    const handleReactivateClick = (userId) => {
        setReactivateUserId(userId);
        setReactivateModalOpen(true);
    };
    const handlePermantnDeleteClick = (userId) => {
        setDeleteUserId(userId);
        setDeleteModalOpen(true);
    };

    const toggleSortByFileSize = () => {
        setSortByFileSize(!sortByFileSize);
    };

    const fetchUsers = async () => {
        setIsLoading(true);
        window.scrollTo(0, 0)
        let queryString = `PageSize=${pageSize}&Page=${page}&OrderByAllFileSize=${sortByFileSize}`;
        const filterString = getFilters();
        if (filterString) {
            queryString += `&${filterString}`;
        }
        if (isActive !== "all") {
            queryString += `&isActive=${(!!isActive)}`;
        }
        if (phoneNumberFilter) {
            queryString += `&FilterByPhoneNumber=${phoneNumberFilter}`;
        }
        try {
            const response = await axios.get(`${baseURL}/User/GetAllExternalUsers?${queryString}`, {});
            if (response.data && response.data.success && response.data.result !== null) {
                setUsers(response.data.data.result);
                setTotalUsers(response.data.data.listCount);
            } else {
                setUsers([]);
                setTotalUsers(0);
            }
        } catch (error) {
        } finally {
            setIsLoading(false);
        }
    };

    const clearFilters = () => {
        setFirstNameFilter('');
        setLastNameFilter('');
        setEmailFilter('');
        setIsActive("all");
        setPhoneNumberFilter('');
        setPersonalNumberFilter('');
        setResetFilters(true);
    };

    useEffect(() => {
        if (resetFilters) {
            void fetchUsers();
            setResetFilters(false);
        }
    }, [resetFilters]);

    const handleDeleteClick = (userId) => {
        setSelectedUserId(userId);
        setModalOpen(true);
    };

    const deleteUser = async () => {
        if (selectedUserId) {
            try {
                await axios.delete(`${baseURL}/User/DeleteUser`, {data: {userId: selectedUserId}});
                setAlertMessage('მომხამრებელი დეაქტივირებულია');
                setShowAlert(true);
                await fetchUsers();
            } catch (error) {
                setAlertMessage('დაფიხსარდა შეცდომა');
                setShowAlert(true);
            }
        }
        setModalOpen(false);
    };



    const permaDeleteUser = async () => {
        if (deleteUserId) {
            try {
                await axios.delete(`${baseURL}/User/DeleteUserCommand`, {data: {id: deleteUserId}});
                setAlertMessage('მომხამრებელი წაშლილია');
                setShowAlert(true);
                await fetchUsers();
            } catch (error) {
                setAlertMessage('დაფიხსარდა შეცდომა');
                setShowAlert(true);
            }
        }
        setDeleteModalOpen(false);
    };

    const handlePageSizeChange = (event) => {
        setPageSize(event.target.value);
        setPage(0);
    };

    const handlePageChange = (event, newPage) => {
        setPage(newPage);
    };


    const reactivateUser = async () => {
        if (reactivateUserId) {
            try {
                const userToReactivate = users.find((user) => user.id === reactivateUserId);


                if (userToReactivate) {
                    const payload = {
                        id: userToReactivate.id,
                        pNumber: userToReactivate.pNumber,
                        firstName: userToReactivate.firstName,
                        lastName: userToReactivate.lastName,
                        phone: userToReactivate.phone,
                        departmentId: userToReactivate.departmentId,
                        isOorganisation: userToReactivate.isOorganisation,
                        canEditObjectRegister: false,
                        orgNumber: userToReactivate.orgNumber,
                        orgName: userToReactivate.orgName,
                        isActive: true,
                        canseeAgenscyAnswer: userToReactivate.canseeAgenscyAnswer,
                    }

                    userToReactivate.isActive = true;

                    await axios.post(`${baseURL}/User/UpdateUser`, payload);
                    setAlertMessage('ოპერაცია წარმატებით დასრულდა!');
                    setShowAlert(true);
                    setReactivateModalOpen(false);
                } else {
                    setAlertMessage('ოპერაცია წარმატებით დასრულდა!');
                    setShowAlert(true);
                    setReactivateModalOpen(false);
                }
            } catch (error) {
                setAlertMessage('ოპერაცია წარმატებით დასრულდა!');
                setShowAlert(true);
                setReactivateModalOpen(false);
            }
        }
    };
    const handleIsActiveChange = (event) => {
        setIsActive(event.target.value);
        setResetFilters(true);
    };

    const cellStyles = {
        cursor: 'pointer',
        transition: 'background-color 0.3s ease', // Smooth transition for background color on hover
        '&:hover': {
            backgroundColor: '#2C3E50', // Darken background on hover
            color: '#BDC3C7' // Lighten text color on hover
        }
    };

    return (
        <div>
            <FormControl>
                <InputLabel id="pageSize-label">Page Size</InputLabel>
            </FormControl>
            <Grid container spacing={2} alignItems="center" style={{
                padding: '20px',
                backgroundColor: '#f7f7f7',
                boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
                borderRadius: '8px',
                marginBottom: '20px'
            }}>

                <Grid item xs={12} sm={6} md={4}>
                    <TextField
                        fullWidth
                        label="სახელი"
                        variant="outlined"
                        value={firstNameFilter}
                        onChange={(e) => setFirstNameFilter(e.target.value)}
                        InputProps={{
                            endAdornment: (
                                firstNameFilter && (
                                    <InputAdornment position="end">
                                        <IconButton onClick={() => setFirstNameFilter('')}>
                                            <MdClear/>
                                        </IconButton>
                                    </InputAdornment>
                                )
                            ),
                        }}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <TextField
                        fullWidth
                        label="გვარი"
                        variant="outlined"
                        value={lastNameFilter}
                        onChange={(e) => setLastNameFilter(e.target.value)}
                        InputProps={{
                            endAdornment: (
                                lastNameFilter && (
                                    <InputAdornment position="end">
                                        <IconButton onClick={() => setLastNameFilter('')}>
                                            <MdClear/>
                                        </IconButton>
                                    </InputAdornment>
                                )
                            ),
                        }}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <TextField
                        fullWidth
                        label="ელ-ფოსტა"
                        variant="outlined"
                        value={emailFilter}
                        onChange={(e) => setEmailFilter(e.target.value)}
                        InputProps={{
                            endAdornment: (
                                emailFilter && (
                                    <InputAdornment position="end">
                                        <IconButton onClick={() => setEmailFilter('')}>
                                            <MdClear/>
                                        </IconButton>
                                    </InputAdornment>
                                )
                            ),
                        }}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <TextField
                        fullWidth
                        label="პირადი ნომერი"
                        variant="outlined"
                        value={personalNumberFilter}
                        InputProps={{
                            endAdornment: (
                                personalNumberFilter && (
                                    <InputAdornment position="end">
                                        <IconButton onClick={() => setPersonalNumberFilter('')}>
                                            <MdClear/>
                                        </IconButton>
                                    </InputAdornment>
                                )
                            ),
                        }}
                        onChange={(e) => {
                            const value = e.target.value;
                            if (/^\d*$/.test(value)) {
                                setPersonalNumberFilter(value);
                            }
                        }}
                        inputProps={{inputMode: 'numeric', pattern: '[0-9]*'}}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <TextField
                        fullWidth
                        label="ტელეფონი"
                        variant="outlined"
                        value={phoneNumberFilter}
                        onChange={(e) => {
                            const value = e.target.value;
                            if (/^\d*$/.test(value)) {
                                setPhoneNumberFilter(value);
                            }
                        }}
                        inputProps={{inputMode: 'numeric', pattern: '[0-9]*'}}
                        InputProps={{
                            endAdornment: (
                                phoneNumberFilter && (
                                    <InputAdornment position="end">
                                        <IconButton onClick={() => setPhoneNumberFilter('')}>
                                            <MdClear/>
                                        </IconButton>
                                    </InputAdornment>
                                )
                            ),
                        }}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <FormControl variant="outlined" fullWidth>
                        <InputLabel id="is-active-label">აქტიური</InputLabel>
                        <Select
                            labelId="is-active-label"
                            id="is-active-select"
                            value={isActive}
                            onChange={handleIsActiveChange}
                            label="აქტიური"
                            endAdornment={
                                isActive !== 'all' && (
                                    <InputAdornment position="end">
                                        <IconButton onClick={() => setIsActive('all')}>
                                            <MdClear/>
                                        </IconButton>
                                    </InputAdornment>
                                )
                            }
                        >
                            <MenuItem value="all">ყველა</MenuItem>
                            <MenuItem value={true}>აქტიური</MenuItem>
                            <MenuItem value={false}>არააქტიური</MenuItem>
                        </Select>
                    </FormControl>
                </Grid>

            </Grid>

            <div style={{display: "flex", gap: 10}}>
                <Button
                    onClick={() => {
                        void fetchUsers();
                    }}
                    variant="contained"
                    color="primary"
                    fullWidth
                    endIcon={<AiOutlineSearch/>}
                >
                    ძიება
                </Button>
                <Button
                    onClick={() => {
                        clearFilters();
                    }}
                    variant="contained"
                    color="error"
                    fullWidth
                    endIcon={<AiOutlineClear/>}
                >
                    ფილტრების წაშლა
                </Button>
            </div>
            {activeFilters.some((filter) => filter.value) && (
                <Grid item xs={12}>
                    <Stack
                        direction="row"
                        spacing={1}
                        flexWrap="wrap"
                        sx={{
                            backgroundColor: '#f1f1f1',
                            padding: '10px',
                            borderRadius: '8px',
                            marginTop: '10px',
                            border: '1px solid #d0d0d0'
                        }}
                    >
                        {activeFilters.map(
                            (filter, index) =>
                                filter.value && (
                                    <Chip
                                        key={index}
                                        label={`${filter.label}: ${filter.value}`}
                                        onDelete={() => {
                                            filter.setValue('');
                                            setResetFilters(true);
                                        }}
                                        color="primary"
                                    />
                                )
                        )}
                    </Stack>
                </Grid>
            )}


            {isLoading || isLoadingMbSize ? (
                    <div style={{minHeight: 800, paddingTop: "25%", minWidth: 1098}}><LoaderCustomFixed/></div>) :
                users.length === 0 ? (
                        <div className="nothing-found-message">
                            არაფერი მოიძებნა!
                        </div>
                    )
                    : (
                        <TableContainer sx={{marginTop: 1, maxHeight: 900, overflow: 'auto'}} component={Paper}>
                            <Table stickyHeader aria-label="sticky table">
                                <TableHead>
                                    <TableRow
                                        sx={{backgroundColor: '#3F51B5'}}> {/* Darker blue background for a more official look */}
                                        <TableCell align="center"
                                                   sx={{
                                                       color: '#FFFFFF',
                                                       backgroundColor: '#3F51B5',
                                                       fontWeight: 'bold',
                                                       padding: '16px'
                                                   }}>
                                            სრული სახელი
                                        </TableCell>
                                        <TableCell align="center"
                                                   sx={{
                                                       color: '#FFFFFF',
                                                       backgroundColor: '#3F51B5',
                                                       fontWeight: 'bold',
                                                       padding: '16px'
                                                   }}>
                                            ელ-ფოსტა
                                        </TableCell>
                                        <TableCell align="center"
                                                   sx={{
                                                       color: '#FFFFFF',
                                                       backgroundColor: '#3F51B5',
                                                       fontWeight: 'bold',
                                                       padding: '16px'
                                                   }}>
                                            აქტიური
                                        </TableCell>
                                        <TableCell align="center"
                                                   sx={{
                                                       color: '#FFFFFF',
                                                       backgroundColor: '#3F51B5',
                                                       fontWeight: 'bold',
                                                       padding: '16px'
                                                   }}>
                                            პირადი ნომერი
                                        </TableCell>
                                        <TableCell align="center"
                                                   sx={{
                                                       color: '#FFFFFF',
                                                       backgroundColor: '#3F51B5',
                                                       fontWeight: 'bold',
                                                       padding: '16px'
                                                   }}>
                                            ტელეფონი
                                        </TableCell>
                                        <TableCell
                                            align="center"
                                            sx={{
                                                color: '#FFFFFF',
                                                backgroundColor: '#3F51B5',
                                                fontWeight: 'bold',
                                                padding: '16px', ...cellStyles
                                            }}
                                            onClick={toggleSortByFileSize}
                                        >
                                            <Stack direction="row" spacing={1} alignItems="center" justifyContent="center">
                                                ატვირთული ფაილების ზომა
                                                {sortByFileSize ? <MdArrowUpward/> : <MdArrowDownward/>}
                                            </Stack>
                                        </TableCell>
                                        <TableCell align="center"
                                                   sx={{
                                                       color: '#FFFFFF',
                                                       backgroundColor: '#3F51B5',
                                                       fontWeight: 'bold',
                                                       padding: '16px'
                                                   }}>
                                            ქმედება
                                        </TableCell>
                                    </TableRow>
                                </TableHead>

                                <TableBody>
                                    {users.map((user, index) => {
                                        const usedSize = user.allFilesSizeMB;
                                        const maxAllowedSize = sizeInMb;
                                        const usagePercentage = Math.min((usedSize / maxAllowedSize) * 100, 100);

                                        return (
                                            <TableRow
                                                sx={{
                                                    height: '113px',
                                                    backgroundColor: index % 2 === 0 ? '#F5F5F5' : '#E0E0E0',
                                                }}
                                                key={user.id}
                                            >

                                                {user.firstName !== " " ? (
                                                    <TableCell sx={{width: 150}}
                                                               align="center">{user.firstName} {user.lastName}</TableCell>
                                                ) : (
                                                    <TableCell sx={{width: 150}}
                                                               align="center">{user.orgName}</TableCell>
                                                )}

                                                <TableCell sx={{width: 150}} align="center">{user.email}</TableCell>
                                                <TableCell sx={{width: 150}}
                                                           align="center">{user.isActive ? 'კი' : 'არა'}</TableCell>
                                                {user.pNumber.length === 11 ? (
                                                    <TableCell sx={{width: 150}} align="center">{user.pNumber}</TableCell>
                                                ) : (
                                                    <TableCell sx={{width: 150}} align="center"></TableCell>
                                                )}

                                                <TableCell sx={{width: 150}} align="center">{user.phone}</TableCell>
                                                <TableCell sx={{width: 250}} align="center">
                                                    <Stack spacing={1} alignItems="center">
                                                        <Typography variant="body2">
                                                            {usedSize} MB / {maxAllowedSize} MB
                                                            ({usagePercentage.toFixed(0)}%)
                                                        </Typography>
                                                        <LinearProgress
                                                            variant="determinate"
                                                            value={usagePercentage}
                                                            sx={{width: '100%', height: 10, borderRadius: 5}}
                                                            color="primary"
                                                        />
                                                    </Stack>
                                                </TableCell>
                                                <TableCell sx={{width: 280}} align="center">
                                                    {user.isActive ? (
                                                        <Stack spacing={2}>
                                                            <Button
                                                                variant="contained"
                                                                color="error"
                                                                fullWidth
                                                                endIcon={<MdBlock/>}
                                                                onClick={() => handleDeleteClick(user.id)}
                                                            >
                                                                დეაქტივაცია
                                                            </Button>
                                                            <Button
                                                                variant="contained"
                                                                color="primary"
                                                                fullWidth
                                                                endIcon={<MdLockReset/>}
                                                                onClick={() => openPasswordResetModal(user.email)}
                                                            >
                                                                პაროლის განახლება
                                                            </Button>
                                                        </Stack>
                                                    ) : (
                                                        <Stack spacing={2}>
                                                            <Button
                                                                variant="contained"
                                                                color="success"
                                                                fullWidth
                                                                endIcon={<MdCheck/>}
                                                                onClick={() => handleReactivateClick(user.id)}
                                                            >
                                                                აქტივაცია
                                                            </Button>
                                                        </Stack>
                                                    )}
                                                    <Stack style={{marginTop: 15}} spacing={2}>
                                                        <Button
                                                            variant="contained"
                                                            color="error"
                                                            fullWidth
                                                            endIcon={<MdDelete/>}
                                                            onClick={() => handlePermantnDeleteClick(user.id)}
                                                        >
                                                            მომხმარებლის წაშლა
                                                        </Button>
                                                    </Stack>
                                                </TableCell>
                                            </TableRow>
                                        );
                                    })}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    )}

            <TablePagination
                component="div"
                count={totalUsers}
                page={page}
                rowsPerPage={pageSize}
                onPageChange={handlePageChange}
                onRowsPerPageChange={handlePageSizeChange}
                labelRowsPerPage="მაჩვენე:"
            />
            <ConfirmationModal
                isOpen={reactivateModalOpen}
                onRequestClose={() => setReactivateModalOpen(false)}
                onConfirm={reactivateUser}
                title="გააქტიურება"
                confirmText="დადასტურება"
                cancelText="გაუქმება"
                message="გსურთ მომხმარებლის გააქტიურება?"
            />
            <ConfirmationModal
                isOpen={passwordResetModalOpen}
                onRequestClose={() => setPasswordResetModalOpen(false)}
                onConfirm={handlePasswordReset}

            />
            <ConfirmationModal
                isOpen={deleteModalOpen}
                onRequestClose={() => setDeleteModalOpen(false)}
                onConfirm={permaDeleteUser}

            />
            <ConfirmationModal
                isOpen={modalOpen}
                onRequestClose={() => setModalOpen(false)}
                onConfirm={deleteUser}
            />
            {showAlert && (
                <CustomAlert
                    message={alertMessage}
                    type={'success'}
                    onClose={() => setShowAlert(false)}
                />
            )}

        </div>
    );
}

export default UserFetcher;
